import DOMPurify from 'dompurify';

interface ArticleContentProps {
  html: string;
}

const ALLOWED_TAGS = [
  'p', 'br', 'strong', 'em', 'b', 'i', 'u', 'a',
  'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'blockquote', 'img', 'figure', 'figcaption', 'span', 'div',
  'table', 'thead', 'tbody', 'tr', 'th', 'td',
];

const ALLOWED_ATTR = ['href', 'target', 'rel', 'src', 'alt', 'width', 'height', 'class', 'style'];

/**
 * Renders sanitised HTML content from Shopify blog articles.
 */
export function ArticleContent({ html }: ArticleContentProps) {
  const clean = DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ADD_ATTR: ['target'],
  });

  return (
    <div
      className="prose prose-lg max-w-none
        prose-headings:font-heading prose-headings:text-foreground
        prose-p:font-body prose-p:text-foreground/85 prose-p:leading-relaxed
        prose-a:text-bronze prose-a:underline prose-a:underline-offset-2
        prose-img:rounded-lg"
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
